export default __webpack_public_path__ + "static/media/LogoClinic.baad4cce.jpg";